import { FolderNamingRule, LibraryRule, PeriodSource, SiteCollectionRule, SiteRule, SubfolderNameSource } from "../../models/auto-generated";

export class Constants {
  public static readonly EntityNameWithSuffixJointer = " ";
  public static readonly DefaultPattern = "{0} {1}";
  public static readonly DefaultNumberOfStartingCharacters = 1;
  public static readonly DefaultUnknownCharacter = "-";

  public static readonly DefaultFolderNamingRule = FolderNamingRule.Pattern;
  public static readonly DefaultFolderNamePattern = "{0}_{1}";
  public static readonly DefaultDocumentLocationPattern = "Document location for '{0}'";

  public static readonly DefaultSuppressLeadBehavior = false;
  public static readonly DefaultSuppressOpportunityBehavior = false;
  public static readonly DefaultSupportOneNote = false;
  public static readonly DefaultBreakRoleInheritance = true;
  public static readonly DefaultCopyRoleAssignments = true;
  public static readonly DefaultSubfolderNameSource =  SubfolderNameSource.LogicalName;
  public static readonly DefaultSkipSubfolder = false;

  public static readonly DefaultLibraryTemplateId = 101;

  public static readonly DefaultPeriod = undefined;
  public static readonly DefaultPeriodSource = PeriodSource.UtcNow;

  public static readonly DefaultLibraryCreateRulePattern = LibraryRule.None;

  public static readonly DefaultSiteCollectionRule = SiteCollectionRule.None;
  public static readonly DefaultWebTemplate = "STS#0";
  public static readonly DefaultLanguage = 1033;

  public static readonly DefaultSiteRule = SiteRule.None;
}
